export default {
    text: {
        language: 'Language',
        save: 'Save',
        ok: 'OK',
        cancel: 'Cancel',
        abort: 'Abort',
        error: 'Error',
        close: 'Close',
        invalid: 'Invalid',
        pleaseSelect: 'Please select',
        other: 'Other',
        all: 'All',
        none: 'None',
        name: 'Name',
        balance: 'Balance',
        getReward: 'Get reward',
        petal: 'Petal',
        type: 'Type',
        cost: 'Cost',
        effects: 'Effects',
        delete: 'delete',
        confirm: 'Confirm',
        deleteConfirmText: 'Are you sure you want to delete?',
        deleteSuccess: 'Successfully deleted!',
        deleteFail: 'Delete failed!',
        tips: 'Tips',
        admin: 'Admin',
        home: 'Home',
        mine: 'Mine'
    },
    language: {
        en: 'English',
        cn: 'Chinese',
        tc: 'Chinese(Traditional)',
        sc: 'Chinese(Simplified)',
        mandarin: 'Chinese(Mandarin)',
        cantonese: 'Chinese(Cantonese)',
        language: 'Language switch'
    },
    home: {
        downloadAlert: 'Petal Android App is available now. You can download it',
        here: 'here',
        downloadTitle: 'Download Petal Android App',
        scanQRCode: 'Scan QR Code below',
        scanWXQRCode: 'Scan code to view WeChat official account',
        talkAbout: 'Discuss the plot with everyone',
        backToTop: 'Back to top',
        downloadFrom: 'Download app from',
        orClick: 'or click',
        downloadDirectly: 'to download directly.',
        notLoggedIn: 'You are not logged in.',
        login: 'Login',
        getReward: 'Got petal ',
        getDaliyAndReferralReward: 'Get daily reward {daily} Petal (and totally got {referral} Petal of referral bonus since last daliy reward)',
        expMore: 'to experience more functions.',
        invitePeople: 'Invite People',
        inviteMsg: 'invites you to join Petal',
        inviteDscription: 'Invite people to become user. Both inviter and invitee will get extra bonus (20% extra daily reward and 5% extra donation reward).',
        copy: 'Copy',
        close: 'Close',
        cancel: 'Cancel',
        version: 'Version',
        about: 'About',
        sendFeedback: 'Send Feedback',
        feedbackToFB: 'Feedback using Facebook',
        feedbackToEMail: 'Feedback using E-mail',
        dailyReward: 'Daily Reward',
        logout: 'Logout',
        introduction: 'Petal Network Community is a video sharing place where users are encouraged to share video contents. User can help to pick out excellent quality video contents by donate gift as well.',
        giftSpec: '【Petal Gift Specification】',
        devlopedBy: 'Developed by Petal Network community',
        finsh: 'Finsh',
        skip: 'Skip'
    },
    map: {
        name: 'COVID19 Map',
        title: 'COVID-19 Live Data',
        region: 'Region',
        cases: 'Cases',
        deaths: 'Deaths',
        newCases: 'New cases',
        newDeaths: 'New deaths',
        deathRate: 'Death Rate',
        R0: 'Trend'
    },
    video: {
        name: 'Video',
        notSupportVideoType: 'Cannot share this kind of video source (Currently only support Youtube/Bilibili/Tencent video).',
        share: 'Share',
        shareVideoSucc: 'Share video successfully!',
        shareVideoFail: 'Failed to share video!',
        donateClickAgain: 'Click button again to donate',
        likeConfirm: 'Are you sure to donate petal this video',
        reduceConfirm: 'Are you sure to reduce petal this video',
        donateToVideoSucc: 'Donate petal to video successfully!',
        reduceVideoPetalSucc: 'Reduce petal to video successfully!',
        donateToVideoFail: 'Failed to donate petal for the video!',
        descriptionL1: 'You can open Youtube/Bilibili/TencentVideo App and',
        descriptionL2: 'share videos to petal network',
        descriptionL3: 'Share Youtube/Bilibili/Tencent videos to petal network',
        descriptionL4: 'Share videos',
        notLogin: 'Cannot share this video before logged in.',
        balance: 'Video petal balance',
        smallGift: 'Small Gift',
        middleGift: 'Middle Gift',
        bigGift: 'Big Gift',
        smallPresentTips: 'After sent small gift, this video will probably move to higher place',
        middlePresentTips: 'After sent middle gift, this video will probably move to higher place',
        bigPresentTips: 'After sent big gift, this video will move to the top place immediately',
        videoGotPetal: 'This video got',
        videoOffline: 'Cannot play video due to this video is offline.',
        chatRoom: 'ChatRoom',
        publish: 'Publish',
        me: 'Me',
        episode: 'Complete'
    },
    label: {
        all: 'All',
        video: 'Video',
        tvseries: 'TV Series',
        movie: 'Movies',
        entertainment: 'Entertainment',
        ent: 'Ent',
        category: 'Category',
        soundTrackLanguage: 'Sound track language',
        subtitleLanguage: 'Subtitle language',
        listTitle: 'Type',
        listLanguageTitle: 'Movie Audio',
        listSubtitle: 'Subtitle'
    },
    subtitle: {
        setStart: 'Set Start',
        setEnd: 'Set End',
        startTime: 'Start Time',
        endTime: 'End Time',
        editNotLogin: 'You must login before editing subtitle. Please login.',
        endEarlier: 'End time cannot be earlier than start time.',
        updateSucc: 'Update subtitle successfully!',
        updateFailed: 'Failed to update subtitle'
    },
    share: {
        shareError: 'Could not share to this app (probably due to you did not install the app',
        supportedVideoSource: 'Supported Video Source',
        shareVideo: 'Share Video',
        shareTo: 'Share To',
        shareBy: 'Shared by',
        shareAt: 'at',
        noCategory: 'Category is not selected',
        noLanguage: 'Language is not selected',
        tvsNotPlaylist: 'Please share the playlist for TV Series or set category to "Video" for this single video',
        videoURL: 'Video URL',
        wechatQrcode: 'Wechat QRcode Share',
        websiteShare: 'Copy video url to a blog or forum',
        rewardExistedL1: 'This video is already shared by',
        rewardExistedL2: 'Since the petal of this video is not positive, the video will be hidden.',
        rewardExistedL3: 'You can donate petal to this video. If you do not like this video, you can input negative petal amount. A negative balance video will not be shown in list.',
        dislikeVideo: 'If you do not like this video, you can spend petal to reduce this video petal balance. A negative balance video will not be shown in list.',
        bilibiliNotSupportSuchShare: 'The Shared URL contains bangumi, so it cannot be Shared. Please rechoose one!',
        bilibiliCategory: 'Bilibili only allow sharing videos in the category of "Video" or "Entertainment". Please set the category to "Video" or "Entertainment".',
        youtubeInvalidUrl: 'invalid Youtube shared url',
        tencentInvalidUrl: 'invalid Tencent Video shared url',
        videoAddress: 'video Address',
        selectCategory: 'Select',
        selectLanguage: 'Select',
        selectSubtitle: 'Select',
        text1: 'Video Category',
        text2: 'Dubbing Language',
        text3: 'Subtitle Language'
    },
    account: {
        balance: 'Your petal balance',
        facebookLoginFailed: 'Failed to login via Facebook!',
        lineLoginFailed: 'Failed to login via Line!',
        twitterLoginFailed: 'Failed to login via Twitter!',
        getTwitterProfileFailed: 'Failed to get Twitter Profile',
        wechatLoginFailed: 'Failed to login via Wechat!',
        wechatNotInstalled: 'Wechat Not Installed!',
        wechatLoginPrompt: 'Please open this url in wechat!',
        getAccessTokenFailed: 'Failed to get access token',
        nextRewardTimeLeft: 'Next daily reward time left',
        insufficientPetal: 'Insufficient Petal balance (need to spend {cost} petal, but you only have {balance} petal).',
        canPickupReward: 'Your reward is ready to pickup!'
    },
    guide: {
        title: 'User Guide',
        loginTitle: 'How to login',
        loginMobileTitle: 'Login',
        loginText1: '1. Open the web page, if you see this alert statement in top, that means you are not logged in. Please click the login button.',
        loginText2: '2. After clicked the login button, you will see a modal pop-up. Then select a social application for login. If you have already logged in before, the Facebook or Line will redirect to Petal directly.',
        loginText3: 'After clicked Line login the following screen will be displayed.',
        loginText4: 'After clicked Facebook login the following screen will be displayed.',
        loginText5: '3. After logged in, you will see your personal information in the upper right corner. Click on avatar and you will see the user menu, including your Petals Balance, Daily Rewards, Invitate People, Send Feedback, Language, About, and Logout.',
        shareTitle: 'How to share',
        shareMobileTitle: 'Share Video',
        shareSubTitle1: '【Share on Website】',
        shareSubTitle2: '【Share on Mobile Phone】',
        shareText1: '1. Open YouTube/Bilibili/TencentVideo page, find the video you want to share, and then copy the URL of video page',
        shareText2: '2. Return to the Petal website, find a "Share" button on the page, as shown in below',
        shareText3: '3. Clicked "Share" button and you will see a modal pop-up with Youtube/Bilibili/TencentVideo Link pasted in URL input. Just select corresponding category and language and finnally click "Share". If server accepted the sharing, a prompt with "Share video successfully" will be shown.',
        shareText4: '1. Open YouTube/Bilibili/TencentVideo app, find the video you want to share, and click "Share" button, as shown in below',
        shareText5: '2. The page that pops up will have an icon for Petal, as shown in below',
        shareText6: '3. Clicked Petal icon, Petal application will open automatically and you will see a modal pop-up with Youtube/Bilibili/TencentVideo Link pasted in URL input. Just select corresponding category and language and finnally click "Share". If server accepted the sharing, a prompt with "Share video successfully" will be shown.',
        ruleTitle: 'Rules and Tips',
        ruleMobileTitle: 'Rules',
        ruleText: '【Rules Introduction】\nUser would receive up to 500 K Daily Reward (according to account activity and random distribution. Watching, donating and sharing video will increase activity point). For the user invited by others, it will have 20% extra bonus (up to 600 K) for daily reward. User can get the Daily Reward in user menu. You can use Petal to donate the videos you like. You could obtain petals from daily reward and inviting users reward.\nThere are 3 kinds of gifts for donation: small gift, middle gift and big gift. The small gift costs 2 K per donation, while the middle gift costs 20 K per donation, and the big gift costs 200 K per donation (75% donated amount will give to video sharer). The donation would change the order of video list (after sent big gift, the video will move to the top place immediately).\nUser can click "Dislike" button to reduce video balance as well. If video becomes negative balance, it will not be shown in video list (click "Dislike" also need spend Petals. User could input amount freely, e.g: 1 or 1000 Petals).\n\n【Unit Conversion】\nThe minimum unit is Petal\n1 K = 1000 Petal\n1 M = 1000 K = 1000000 Petal'
    },
    error: {
        msg200: 'Failed to create user',
        msg201: 'Unsupported social application',
        msg203: 'Wechat login Auth denied',
        msg204: 'Line login Auth denied',
        msg205: 'Failed to get access token',
        msg206: 'Failed to verify Line token',
        msg404: 'Not found',
        msg999: 'Server is under maintenance. Please retry later. Sorry for the inconvenience!',
        backHome: 'Back Home',
        alreadyShared: 'The copy link video has been shared'
    },
    navText: {
        placeholder: 'Enter the content you want to search',
        search: 'Search',
        share: 'SHARE',
        sign: 'REWARD',
        mine: 'MINE',
        loginPanelTitle: 'After logging in, you can',
        loginPanelText1: 'Get Petals',
        loginPanelText2: 'Share Video',
        loginPanelText3: 'Review Film',
        loginPanelBtnText: 'Log in',
        signText: 'Sign in',
        select: 'Filter'
    },
    shareCategory: [
        {
            label: 'TV Series',
            value: 'tvseries'
        },
        {
            label: 'Movies',
            value: 'movies'
        },
        {
            label: 'Entertainment',
            value: 'entertainment'
        },
        {
            label: 'Other',
            value: 'other'
        }
    ],
    shareSound: [
        {
            label: 'English',
            value: 'english'
        },
        {
            label: 'Chinese(Mandarin)',
            value: 'mandarin'
        },
        {
            label: 'Chinese(Cantonese)',
            value: 'cantonese'
        },
        {
            label: 'Other/None',
            value: 'other'
        }
    ],
    shareLanguage: [
        {
            label: 'English',
            value: 'english'
        },
        {
            label: 'Chinese(Simplified)',
            value: 'simplified_chinese'
        },
        {
            label: 'Chinese(Traditional)',
            value: 'traditional_chinese'
        },
        {
            label: 'Other/None',
            value: 'other'
        }
    ],
    shareSubCategoryMovie: [
        {
            label: 'Comedy',
            value: 'comedy'
        },
        {
            label: 'Love',
            value: 'love'
        },
        {
            label: 'Action',
            value: 'action'
        },
        {
            label: 'Crime',
            value: 'crime'
        },
        {
            label: 'Youth',
            value: 'youth'
        },
        {
            label: 'Crux',
            value: 'crux'
        },
        {
            label: 'Other',
            value: 'other'
        }
    ],
    shareSubCategoryTVseries: [
        {
            label: 'Costume',
            value: 'costume'
        },
        {
            label: 'Idol',
            value: 'idol'
        },
        {
            label: 'Youth',
            value: 'youth'
        },
        {
            label: 'City',
            value: 'city'
        },
        {
            label: 'Crux',
            value: 'crux'
        },
        {
            label: 'Comedy',
            value: 'comedy'
        },
        {
            label: 'Family',
            value: 'family'
        },
        {
            label: 'Internet',
            value: 'internet'
        },
        {
            label: 'Other',
            value: 'other'
        }
    ],
    shareSubCategoryEntertainment: [
        {
            label: 'Talk show',
            value: 'talk show'
        },
        {
            label: 'Interview',
            value: 'interview'
        },
        {
            label: 'Parent-child',
            value: 'parent child'
        },
        {
            label: 'Food',
            value: 'food'
        },
        {
            label: 'Culture',
            value: 'culture'
        },
        {
            label: 'Music',
            value: 'music'
        },
        {
            label: 'Dance',
            value: 'dance'
        },
        {
            label: 'Finance',
            value: 'finance'
        },
        {
            label: 'Other',
            value: 'other'
        }
    ],
    shareSubCategoryOther: [
        {
            label: 'Other',
            value: 'other'
        }
    ],
    newTextForm: {
        twiLogin: 'Login by Twitter',
        facebookLogin: 'Login by Facebook',
        wechatLogin: 'Login by Wechat',
        lineLogin: 'Login by Line',
        invateRule: 'Invate Rule',
        copyInvateLink: 'Copy Invate Link',
        loginBottomText: 'By logging in, you agree to the',
        userXieyi: "'user agreement'",
        and: 'and',
        yinsiXieyi: "'privacy policy'",
        copyTip: 'Copy the URL of the video you want to share and paste it here'
    }
}



// WEBPACK FOOTER //
// ./src/language/locales/en.js